module.exports = __webpack_public_path__ + "img/13_Credits_iPad_P.a836323c.jpg";